import Vue from "vue";

const URL = "/db/laman";
const API_URL = URL + "/api/";

const state = {
  laman: []
};

const getters = {
  lamanByLaman(state, getters, rootState) {
    return state.laman.filter(o => o.id_laman == rootState.id_laman$);
  }
};

const mutations = {
  SET_LAMAN(state, payload) {
    state.laman = payload;
  }
};

const actions = {
  GET_LAMAN({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(API_URL).then(res => {
      commit("SET_LAMAN", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
